import rawTracks from './bgm_tracks.json';

export interface BgmTrack {
  id: string;
  title: string;
  url: string;
  sunoUrl?: string;
  tags?: string;
  imageUrl?: string;
  duration?: number;
  category: 'guandan_anthem' | 'classical_epic' | 'ambient_folk' | 'worship_lyric' | string;
  categoryLabel: string;
}

export const SUNO_BGM_PLAYLIST: BgmTrack[] = rawTracks as BgmTrack[];
export const BGM_PLAYLIST: BgmTrack[] = SUNO_BGM_PLAYLIST;

/**
 * Loads the curated local authentic tracks bundled on Cloudflare CDN.
 */
export async function fetchLiveSunoTracks(): Promise<BgmTrack[]> {
  return SUNO_BGM_PLAYLIST;
}

function mergeTracks(baseList: BgmTrack[], liveList: BgmTrack[]): BgmTrack[] {
  const merged: BgmTrack[] = [...liveList];
  const seenIds = new Set(liveList.map((t) => t.id));

  for (const t of baseList) {
    if (!seenIds.has(t.id)) {
      merged.push(t);
      seenIds.add(t.id);
    }
  }

  return merged;
}
